var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagicWand2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 49,
    viewBox: "0 0 55 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6985 13.3562L0 43.0547L4.94975 48.0044L34.6482 18.306L29.6985 13.3562Z",
    fill: "#2B6299"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0624 6.9899L25.2554 17.7969L30.2051 22.7466L41.0121 11.9396L36.0624 6.9899Z",
    fill: "#8CBFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0061 0L24.8546 3.15147L28.0061 4L24.8546 4.84853L24.0061 8L23.1576 4.84853L20.0061 4L23.1576 3.15147L24.0061 0Z",
    fill: "#3B82C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0061 19L43.8546 22.1515L47.0061 23L43.8546 23.8485L43.0061 27L42.1576 23.8485L39.0061 23L42.1576 22.1515L43.0061 19Z",
    fill: "#3B82C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0061 1L49.2789 5.72721L54.0061 7L49.2789 8.27279L48.0061 13L46.7333 8.27279L42.0061 7L46.7333 5.72721L48.0061 1Z",
    fill: "#3B82C9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWand2);
export default __webpack_public_path__ + "static/media/magic_wand_2.157a5013.svg";
export { ForwardRef as ReactComponent };